export enum DownloadColorProfileOptionType {
  RGB = 'RGB',
  CMYK = 'CMYK',
}
